import Tool, { type IToolActionInput } from './Tool';
import Shortcut from '../utils/Shortcut';

class ToolExportPNG extends Tool {
  static toolName = 'Export to PNG';
  static shortcut = new Shortcut('Shift+Cmd+E');

  static action({ controller }: IToolActionInput) {
    const canvas = controller.canvas;
    const usedRect = canvas.usedPortion();

    const result = canvas.renderToPng(usedRect);

    if (!result.success) {
      controller.actionShowMessage({ message: result.error, type: 'error' });
      return;
    }

    // Create a fake link to trigger the download.
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.setAttribute('style', 'display: none');
    a.target = '_blank';

    a.href = result.dataUrl;

    a.download = `${controller.exportFileName}.png`;
    a.click();
    a.remove();
  }

  static enabled() {
    return true;
  }
}

export default ToolExportPNG;
